import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { YandexMethodNames, YandexCounters, RemontDevMetricCounterNumber } from './analytics.constants';
var Analytics = /*#__PURE__*/function () {
  function Analytics(accounts) {
    _classCallCheck(this, Analytics);
    this.accounts = accounts;
    this.callQueue = [];
    if (accounts.yandex.includes(RemontDevMetricCounterNumber)) {
      this.sendEvent(RemontDevMetricCounterNumber, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true
      });
    }
  }
  _createClass(Analytics, [{
    key: "sendEvent",
    value: function sendEvent() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if ('ym' in window && window.ym != null && typeof window.ym === 'function') {
        var counterIds = this.accounts.yandex;
        if (this.callQueue.length !== 0) {
          this.callQueue.forEach(function (deferredCall) {
            counterIds.forEach(function (counterId) {
              Analytics.yandexCall.apply(Analytics, [counterId].concat(_toConsumableArray(deferredCall.args)));
            });
          });
          this.callQueue = [];
        }
        counterIds.forEach(function (counterId) {
          Analytics.yandexCall.apply(Analytics, [counterId].concat(args));
        });
      } else {
        this.callQueue.push({
          args: args
        });
      }
    }
  }], [{
    key: "yandexCall",
    value: function yandexCall(counter) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      if (YandexMethodNames.includes(args[0])) {
        var _window;
        var methodName = args.shift();
        (_window = window).ym.apply(_window, [counter, methodName].concat(args));
      } else {
        var _window2;
        (_window2 = window).ym.apply(_window2, [counter, Analytics.YandexDefaultMethodName].concat(args));
      }
    }
  }]);
  return Analytics;
}();
Analytics.YandexDefaultMethodName = 'reachGoal';
export var analytics = new Analytics({
  yandex: YandexCounters
});